import ApplicationController from '../../../javascript/controllers/application_controller'
import { patch } from '@rails/request.js'

export default class extends ApplicationController {
  static targets = ['button', 'panel', 'dismiss', 'dismissAllButton']
  static values = { markSeenUrl: String }

  toggle() {
    if (this.panelTarget.classList.contains('hidden')) {
      this.open()
    } else {
      this.close()
    }
  }

  async open() {
    this.panelTarget.classList.remove('hidden')
    try {
      await patch(this.markSeenUrlValue, { responseKind: 'turbo-stream' })
    } catch (error) {
      this.reportError(error, { action: 'open' })
    }
  }

  close() {
    this.panelTarget.classList.add('hidden')
  }

  closeOnClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  dismissTargetDisconnected() {
    if (!this.hasDismissTarget && this.hasDismissAllButtonTarget) {
      this.dismissAllButtonTarget.classList.add('hidden')
    }
  }
}
